<p-dialog [(visible)]="visible" [modal]="true" [dismissableMask]="true" [style]="{ width: '640px', maxWidth: '95vw' }"
  [header]="title | translate" (onHide)="closeModal()">
  <div class="header">
    <img [src]="image" width="150px" height="auto" [alt]="logoAlt" />
    <div>
      <div class="subtitle">{{ subtitleKey | translate }}</div>
      <div class="meta">v{{ version }} · {{ build }}</div>
      <div>
        Covariance P.C. – <a href="https://www.covariance.gr" target="_blank" rel="noopener">www.covariance.gr</a>
      </div>
    </div>
  </div>

  <p-divider></p-divider>


  <div>
    <h5>{{"ABOUT.CONTACT" | translate}}</h5>
    {{"ABOUT.EMAIL" | translate}}: <a href="mailto:support@covariance.gr">support&#64;covariance.gr</a><br />
    {{"ABOUT.TEL" | translate}}: <a href="tel:+302160012940">+30 216 0012 940</a>
  </div>
  <div class="copy">© 2025 Covariance P.C. {{"ABOUT.All_rights_reserved" | translate}}.</div>

  <p-divider></p-divider>

  <h5 id="disclaimer-title">{{"ABOUT.Disclaimer" | translate}}</h5>
  <p-scrollPanel [style]="{ height: '200px' }" [attr.aria-labelledby]="'disclaimer-title'">
    <p>
      {{disclaimerText | translate}}
    </p>
  </p-scrollPanel>

  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" [label]="'CASE_DETAIL.CLOSE' | translate"
      (click)="closeModal()"></button>
  </ng-template>
</p-dialog>